module.exports = __webpack_public_path__ + "assets/img/copper.6da7f4da.png";